import { supabase } from './supabaseClient';

export async function createCheckoutSession(
  priceId: string,
  mode: 'payment' | 'subscription',
  options?: { team_name?: string; success_url?: string; cancel_url?: string },
) {
  const apiUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/stripe-checkout`;

  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) {
    throw new Error('User must be authenticated to create a checkout session');
  }

  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({
      price_id: priceId,
      mode,
      success_url: options?.success_url || `${window.location.origin}/success`,
      cancel_url: options?.cancel_url || `${window.location.origin}/pricing`,
      ...(options?.team_name ? { team_name: options.team_name } : {}),
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const errorMessage = errorData.error || 'Failed to create checkout session';
    console.error('Checkout session creation failed:', {
      status: response.status,
      statusText: response.statusText,
      error: errorMessage
    });
    throw new Error(errorMessage);
  }

  const { url } = await response.json();
  return url;
}

export async function redirectToCheckout(
  priceId: string,
  mode: 'payment' | 'subscription',
  options?: { team_name?: string; success_url?: string; cancel_url?: string },
) {
  const url = await createCheckoutSession(priceId, mode, options);
  window.location.href = url;
}